import React from "react";

import { StyledIconBtn } from "./styles/IconBtn";

const IconBtn = ({
  bgColor = "primary",
  hoverColor = "orange",
  color = "white",
  ...props
}) => {
  return (
    <StyledIconBtn
      {...props}
      $bgColor={bgColor}
      $hoverColor={hoverColor}
      $color={color}
    />
  );
};

export default IconBtn;
